import React, { useState } from "react";
import style from "./Files.module.scss";
import { Button } from "reactstrap";
import { Field } from "../../../Order/Field/Field";

const Files = ({ ioType, id, dispatch, readonly, files, downloadFile }) => {
  const [plus100, setplus100] = useState(false);
  const uploadFiles = () => {
    const addedFiles = Object.values(event.target.files).map((f) => ({
      id: Math.random().toString(36).substring(2, 15),
      name: f.name,
      type: f.type,
      data: f,
    }));
    let hasError = false;
    for (var i = 0; i < addedFiles.length; i++) {
      if (addedFiles[i].name.length > 100) {
        hasError = true;
        setplus100(true);
      }
    }
    if (!hasError) {
      setplus100(false);
      dispatch({
        type: "UPDATE_FILES",
        props: { type: "Add", files: addedFiles },
      });
    }
  };

  const deleteFile = (id) => {
    dispatch({
      type: "UPDATE_FILES",
      props: { type: "Delete", id },
    });
  };

  const doDownloadFile = (fileId) => {
    downloadFile({
      id,
      ioType,
      fileId,
    })
      .then((r) => r.response)
      .then((r) => {
        if (r.url != "") {
          window.open(r.url);
        }
      });
  };

  return (
    <Field label={"Documents"}>
      <div className={style.root}>
        <div style={{ width: "100%" }}>
          {files.length == 0 ? (
            <span className={style.empty}>No documents (name length less than 100 characters)</span>
          ) : (
            <React.Fragment>
              {!readonly && (
                <span className={style.add}>
                  Select document(s) to upload (name length less than 100 characters)
                </span>
              )}
            </React.Fragment>
          )}
          {!readonly && (
            <button
              className={`mr-1 btn btn-light ${style.upload}`}
              style={{ float: "right" }}
              tooltip="Upload file"
              tooltip-position="bottom"
            >
              <img />
              <input type="file" className={style.inputFile} multiple onChange={uploadFiles} />
            </button>
          )}
          <p className={plus100 ? style.error : style.error2}>The name is longer than 100 characters</p>
        </div>

        <FileList readonly={readonly} downloadFile={doDownloadFile} files={files} deleteFile={deleteFile} />
      </div>
    </Field>
  );
};

const FileList = ({ files, readonly, deleteFile, downloadFile }) => {
  return (
    <div className={style.list}>
      {files.map((f) => (
        <div key={`f-${f.id}`} className={style.attachment}>
          <span className={style.link} onClick={() => downloadFile(f.id)}>
            <i className="fa fa-file-code-o mr-1" aria-hidden="true"></i>
            <span className={style.fileName}>{f.name}</span>
          </span>
          {!readonly && (
            <Button
              color="btn-outline-primary btn-sm"
              disabled={false}
              onClick={() => deleteFile(f.id)}
              style={{ color: "#d83737" }}
            >
              <i className="fa fa-close"></i>
            </Button>
          )}
          <hr />
        </div>
      ))}
    </div>
  );
};

export default Files;
